import { createSelector } from 'reselect';

// const networkSelector = (state: any) => state.network;
const appSelector = (state: any) => state.app;

export const appGetNNHashSelector = createSelector(
  appSelector,
  (app) => app.nnHash
);

export const appShowWebNavigationBarSelector = createSelector(
  appSelector,
  (app) => app.showWebNavigationBar
);

export const appGetTitleSelector = createSelector(
  appSelector,
  (app) => app.title
);


export default appSelector;
